import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Modal, Form, Input, Button, message } from "antd";
import InputMask from "react-input-mask";
import Loading from "../../components/Loading";
import { createLoadingSelector } from "../../store/api/selectors";
import { getProduct, setProduct, putProduct } from "./Classify/actions";

const initialValues = {
  formData: {
    Produto: {
      Id: null,
      CodigoProduto: "",
      Ean: "",
      Ncm: "",
      Ex: "",
      Cest: "",
      Descricao: "",
    },
  },
};

class ModalProduct extends Component {
  state = {
    ...initialValues,
    activeTabKey: JSON.parse(
      sessionStorage.getItem("eRecuperadorActiveTabCompany")
    ),
  };

  componentDidUpdate(prevProps) {
    const { product, status } = this.props;

    if (prevProps.product !== product) {
      this.setState({
        formData: {
          ...this.state.formData,
          Produto: {
            Id: product.Id || "",
            CodigoProduto: product.CodigoProduto || "",
            Ean: product.Ean || "",
            Ncm: product.Ncm || "",
            Ex: product.Ex || "",
            Cest: product.Cest || "",
            Descricao: product.Descricao || "",
          },
        },
      });
    }

    if (status === 200) {
      this.closeModal();
      this.props.handleFilters();
    }

    if (status === 400) {
      this.closeModal();
      this.props.handleFilters();
    }
  }

  handleChange = (e) => {
    const value = e.target.value,
    name = e.target.name;

    if((name === 'CodigoProduto' || name === 'Descricao') && typeof(value) === 'string'){
      this.setState({
        formData: {
          ...this.state.formData,
          Produto: {
            ...this.state.formData.Produto,
            [name]: value.slice(0, 100),
          },
        },
      });
    }else if(name === 'Ean' && typeof(value) === 'string'){
      this.setState({
        formData: {
          ...this.state.formData,
          Produto: {
            ...this.state.formData.Produto,
            [name]: value.slice(0, 45),
          },
        },
      });
    }else{
      this.setState({
        formData: {
          ...this.state.formData,
          Produto: {
            ...this.state.formData.Produto,
            [name]: value,
          },
        },
      });
    }    
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { formData } = this.state;
    const { isEdit } = this.props;
    if (formData.Produto.CodigoProduto === "" || formData.Produto.Descricao === "") {
      message.error("Descrição e o código do item são obrigatórios")
      return;
    }
    if (!isEdit) {
      this.props.setProduct(formData);
    } else {
      this.props.putProduct(formData);
    }

    this.props.changePage(1);
  };

  closeModal = () => {
    this.props.visibleModal(false);
  };

  render() {
    const { visible, isEdit, isGetFetching, isSetFetching, status, onRequest } = this.props;
    const { formData, activeTabKey } = this.state;
    let fetching = isSetFetching;
    if (status === null && onRequest === false) {
      fetching = 0
    }
    return (
      <Modal
        title={`${isEdit ? "Editar" : "Cadastrar"} produto`}
        visible={visible}
        closable={false}
        footer={null}
      >
        {!!isGetFetching ? <Loading /> : null}

        <Form onSubmit={this.handleSubmit}>
          <div className="row">
            <div className="form-group col-md-6">
              <label className="col-form-label">Código do item</label>
              <Input
                className="form-control"
                name="CodigoProduto"
                type="text"
                maxLength={100}
                value={formData.Produto.CodigoProduto}
                onChange={this.handleChange}
                disabled={isEdit}
              />
            </div>

            <div className="form-group col-md-6">
              <label className="col-form-label">EAN</label>
              <Input
                className="form-control"
                name="Ean"
                type="text"
                value={formData.Produto.Ean}
                onChange={this.handleChange}
              />
            </div>

            <div
              className={`form-group col-md-${activeTabKey === 5 ? "4" : "6"}`}
            >
              <label className="col-form-label">NCM</label>
              <InputMask
                className="form-control"
                id="Ncm"
                name="Ncm"
                value={formData.Produto.Ncm}
                mask={"9999.99.99"}
                onChange={this.handleChange}
              />
            </div>

            <div
              className={`form-group col-md-${activeTabKey === 5 ? "4" : "6"}`}
            >
              <label className="col-form-label">EX</label>
              <InputMask
                className="form-control"
                name="Ex"
                value={formData.Produto.Ex}
                mask={"999"}
                onChange={this.handleChange}
              />
            </div>

            {activeTabKey === 5 ? (
              <div className="form-group col-md-4">
                <label className="col-form-label">CEST</label>
                <InputMask
                  className="form-control"
                  name="Cest"
                  value={formData.Produto.Cest}
                  mask={"99.999.99"}
                  onChange={this.handleChange}
                />
              </div>
            ) : null}

            <div className="form-group col-md-12">
              <label className="col-form-label">Descrição</label>
              <Input
                className="form-control"
                name="Descricao"
                type="text"
                value={formData.Produto.Descricao}
                onChange={this.handleChange}
              />
            </div>
          </div>

          <div className="ant-modal-footer">
            <Button
              type="default"
              loading={fetching}
              onClick={this.closeModal}
            >
              Cancelar
            </Button>
            <Button type="primary" htmlType="submit" loading={fetching}>
              {isEdit ? "Salvar" : "Cadastrar"}
            </Button>
          </div>
        </Form>
      </Modal>
    );
  }
}

const loadingGetProduct = createLoadingSelector(["GET_PRODUCT"]),
  loadingSetProduct = createLoadingSelector(["SET_PRODUCT"]),
  loadingPutProduct = createLoadingSelector(["PUT_PRODUCT"]);

const mapStateToProps = (state) => ({
  status: state.products.status,
  onRequest: state.products.onRequest,
  isGetFetching: loadingGetProduct(state),
  isSetFetching: loadingSetProduct(state) || loadingPutProduct(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ getProduct, setProduct, putProduct }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ModalProduct);
